import { Text } from "native-base";

export const ValueDisplayLabel = ({ label }) => (
  <Text style={{ fontFamily: "Barlow_600SemiBold" }} color="gray.1300">
    {label}:
  </Text>
);
